import { createSlice } from '@reduxjs/toolkit'

export const clienteSlice = createSlice({
  name: 'cliente',
  initialState: {
    clienteComPaginacao: [],
    clienteSemPaginacao: [],
    clienteIndividual: [],
    ultimosMovCliente: false
  },
  reducers: {
    addClienteComPaginacao: (state, action) => {
      state.clienteComPaginacao = action.payload
    },
    addClienteSemPaginacao: (state, action) => {
      state.clienteSemPaginacao = action.payload
    },
    addClienteIndividual: (state, action) => {
      state.clienteIndividual = action.payload
    },
    validarUltimosMovCliente: (state, action) => {
      state.ultimosMovCliente = action.payload
    }
  },
});

export const { addClienteComPaginacao, addClienteSemPaginacao, addClienteIndividual, validarUltimosMovCliente } = clienteSlice.actions
export default clienteSlice.reducer